<template>
  <div class="col-12">
    <div class="row">
      <div class="col-lg-4"></div>
      <div class="col-lg-4">
        <Register></Register>
      </div>
      <div class="col-lg-4"></div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";

export default {
  components: { Register }
}
</script>

<style scoped>

</style>